import {
    Avatar, Backdrop, Button, createTheme, Dialog, DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton, List,
    ListItem, ListItemAvatar, ListItemText, MuiThemeProvider, SelectProps, styled,
    TextField, Typography
} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Add as AddIcon, CloudUpload, Delete as DeleteIcon, PictureAsPdf } from '@material-ui/icons'
import Tooltip from '@mui/material/Tooltip'
import MUIDataTable from 'mui-datatables'
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import SelectInvoiceType from '../../../components/Form/SelectInvoiceType'
import AlertDialog from '../../../components/ui/AlertDialog'
import ButtonUI from '../../../components/ui/ButtonUI'
import { useAuth } from '../../../hooks/auth'
import { MvmInvoice } from '../../../interfaces/Mvm'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import { useStyles } from '../Style'
import { FileUploadUtil } from '../../../utils/FileUpload'

type props =  any;
interface IFormInput {
    invoiceKey: any;
    invoiceType: any;
} 
const MvmInvoiceItemsList: React.FC<props> = ({ control, name, allowAdd, allowDelete, Mvm, title, isRack, entranceDate, allowUploadFile = true, setTypeManually = false }) => {

    const classes = useStyles()
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tGeneral } = useTranslation("General")
    const { enqueueSnackbar } = useSnackbar()
    const { user, isMopar, isPortoReal } = useAuth()
    const { t: tMvmInvoice } = useTranslation(isMopar() ? "MvmInvoiceMopar" : "MvmInvoice")
    const [circularLoading, setCircularLoading] = useState(false)
    const [selectInvoiceType, setSelectInvoiceType] = useState(false)
    const [unknownTypeInvoice, setUnknownTypeInvoice] = useState<null | MvmInvoice>(null)
    const { fields: _fields, append, remove, update } = useFieldArray({ control, name: name })
    const fields = _fields as Record<string, any>[];
    const invoiceTypes = [ 'V', 'E', 'A', 'G', 'I', 'M', 'P', 'R', 'T'] 
    const refFieldInvoiceKey = useRef<HTMLInputElement>(null)
    const refFieldInvoiceType = useRef<SelectProps | null>(null)    
    const [invoiceItems, setInvoiceItems] = useState<any>([])
    const [loadingFileInvoice, setLoadingFileInvoice] = useState<string>('')
    const { control: internalControl, reset, getValues } = useForm<IFormInput>({
        defaultValues: {
            invoiceKey:  '', 
            invoiceType: null            
        }
    })
    useEffect(() => {
        
        let tempInvoiceItems = []
        for (let i = 0; i < fields.length; i++) {

            let invoiceKey = fields[i]["invoiceKey"]
            let invoiceNumber = fields[i]["invoiceNumber"]
            let invoiceDate = fields[i]["invoiceDate"]
            let invoiceType = fields[i]["invoiceType"]
            let materialReturnDescription = fields[i]["materialReturnDescription"]
            let invoiceReleaseReturnDescription = fields[i]["invoiceReleaseReturnDescription"]
            let companyCodeLegacy = fields[i]["companyCodeLegacy"]
            
            if(fields[i]["items"].length > 0){
                let items = fields[i]["items"].map((element: { partnumberId: any; partnumberCode: any; itemQuantity: any; bonusNumber: any; bonusRegisteredQuantity: any; itemDescription: any; }) => ({ 
                    invoiceFieldPosition: i,  
                    invoiceKey: invoiceKey,
                    invoiceNumber: invoiceNumber,
                    invoiceDate: invoiceDate,
                    invoiceType: invoiceType,
                    partNumberCode: element.partnumberCode,
                    partNumberDescription: element.itemDescription,
                    itemQuantity: element.itemQuantity,
                    bonusNumber: element.bonusNumber,
                    bonusRegisteredQuantity: element.bonusRegisteredQuantity,
                    materialReturnDescription: materialReturnDescription,
                    invoiceReleaseReturnDescription: invoiceReleaseReturnDescription,
                    companyCodeLegacy: companyCodeLegacy
                }))

                for (let j = 0; j < items.length; j++) {
                    tempInvoiceItems.push(items[j])
                }
            }
            else {
                
                tempInvoiceItems.push({ 
                    invoiceFieldPosition: i,  
                    invoiceKey: invoiceKey,
                    invoiceNumber: invoiceNumber,
                    invoiceDate: invoiceDate,
                    invoiceType: invoiceType,
                    partNumberCode: null,
                    partNumberDescription: null,
                    itemQuantity: null,
                    bonusNumber: null,
                    bonusQuantity: null,
                    materialReturnDescription: materialReturnDescription,
                    invoiceReleaseReturnDescription: invoiceReleaseReturnDescription,
                    companyCodeLegacy: companyCodeLegacy})
            }
        }

        setInvoiceItems(tempInvoiceItems)


    }, [fields])

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    const columns = [
        {
            name: 'invoiceFieldPosition',
            options: {
                display: false,
            }
        },
        {
            name: 'invoiceKey',
            label: String(tMvm('invoiceKey')),
            options: {
                setCellProps: () => ({
                    align: "left",
                }),
            }
        },
        {
            name: 'invoiceNumber',
            label: String(tMvm('invoiceNumber')),

            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        },
        {
            name: 'invoiceDate',
            label: String(tMvm('invoiceDate')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateShort(value);
                }
            }
        },
        {
            name: 'invoiceType',
            label: String(tMvm('invoiceType')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return tMvmInvoice("invoiceType_" + value);
                }
            }
        },
        {
            name: 'partNumberCode',
            label: String(tMvm(isRack ? 'rackCode' : 'partNumberCode')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'partNumberDescription',
            label: String(tMvm(isRack ? 'rackDescription' : 'partNumberDescription')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'itemQuantity',
            label: String(tMvm('itemQuantity')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'bonusNumber',
            label: String(tMvm('bonusNumber')),
            options: {
                display: !isRack,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'bonusRegisteredQuantity',
            label: String(tMvm('bonusQuantity')),
            options: {
                display: !isRack,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'materialReturnDescription',
            label: String(tMvm('processingStatus')),
            options: {
                display: !isRack,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'companyCodeLegacy',
            label: String(tMvm('companyCodeLegacy')),
            options: {
                display: isRack || +user.company.plantID === 1 ,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: "",
            options: {
                display: !isPortoReal(),
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0], tableMeta.rowIndex)
                )
            }
        },
    ]

        // Verificar se a nota está em contingência (tpEmis)
    // O caractere que indica se a nota foi emitida em contingência é o 34
    // 1 = Emissão normal (não em contingência)
    // 2 = Contingência FS-IA, com impressão do DANFE em formulário de segurança
    // 3 = Contingência SCAN (Sistema de Contingência do Ambiente Nacional)
    // 4 = Contingência DPEC (Declaração Prévia da Emissão em Contingência)
    // 5 = Contingência FS-DA, com impressão do DANFE em formulário de segurança
    // 6 = Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)
    // 7 = Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)
    const isContingency = (invoiceKey: string) : boolean => {
        return invoiceKey.substring(34, 35) !== '1'
    }
    
    const associateFile = async (event: any, rowIndex: number) => {
        var el = fields[rowIndex]
        
        if(event.target.files && event.target.files[0]) {

            const fileType = event.target.files[0].type
            const invoiceKey = el['invoiceKey']
            const fileName = `${invoiceKey}.pdf`
            let fileAlias = event.target.files[0].name

            if (fileAlias.length >= 15) {
                const aliasStart = fileAlias.substring(0, 7)
                const aliasEnd = fileAlias.substring(fileAlias.length - 4, fileAlias.length)
                fileAlias =  `${aliasStart}.. ${aliasEnd}`
            }


            if (fileType !== 'application/pdf') {
                enqueueSnackbar(tGeneral("fileValidationPDF"), { variant: 'warning' })
                return
            }

            setLoadingFileInvoice(invoiceKey)
           let fileBytes = null;
            const inputFile = event.target.files[0];

            //Ler bytes do arquivo:
            await FileUploadUtil.getUploadedFileContent({ files: [ inputFile ] }).then((res) => {
                const response = res[0];
                fileBytes = response !== null ? response.content.toString().split(',')[1] : "";
            });
            
            MvmApi.UploadFile({
                folderName: 'Mvm',
                fileFullName: fileName,
                originalFileName: fileName,
                file: fileBytes,
                name: inputFile.name,
                contentType: inputFile.type,
            })
            .then((resp) => {
                el['fileAlias'] = fileAlias
                el['hasFile'] = true
                enqueueSnackbar(tGeneral('fileUploadSuccess'), { variant: 'success' })
                update(rowIndex, el)
            })
            .finally(() => setLoadingFileInvoice(''))
        }
    }

    const downloadFile = (invoiceKey: string) => {
        
        setLoadingFileInvoice(invoiceKey)
        MvmApi.DownloadFile(`${invoiceKey}.pdf`, 'Mvm')
            .then((resp: any) => {

                const byteCharacters = atob(resp.content);

                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = invoiceKey;
                link.click();
            })
            .finally(()=> setLoadingFileInvoice(''))
    }

    const renderButtons = (invoiceRowIndex: any, rowIndex: any) => {
        if (fields === undefined || fields.length <= invoiceRowIndex) return <></>;

        let justAdded = fields[invoiceRowIndex]['mvmId'] === 0;
        
        const invoiceKey = fields[invoiceRowIndex]['invoiceKey']
        
        let contingency = isContingency(invoiceKey)

        if (contingency && rowIndex > 0 && invoiceItems[rowIndex - 1].invoiceKey === invoiceKey) {
            contingency = false
        }

        const VisuallyHiddenInput = styled('input')({
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute',
            bottom: 0,
            left: 0,
            whiteSpace: 'nowrap',
            width: 1,
            border: 'none',
            teste: "tese"
          });

        var uploadLabel = <></>
        let hasFile = false 

        if (fields[invoiceRowIndex]['fileAlias'])
        {
            hasFile = true
            uploadLabel = <span>{fields[invoiceRowIndex]['fileAlias']}</span>
        }
        else if (!justAdded && fields[invoiceRowIndex]['hasFile']) {
            hasFile = true
            uploadLabel = <span>{tGeneral('selectFileContingencyInvoice')}</span>
        }
        else
            uploadLabel = <span style={{color: 'red'}}>{tGeneral('selectFileContingencyInvoice')}</span>
        
        return (
        <>
            {contingency && 
            <>
                {loadingFileInvoice === invoiceKey ?
                    <CircularProgress color="inherit" size={10} />
                : 
                    <>
                        {allowUploadFile && <Button style={{marginRight: 10}}
                            component="label" 
                            onChange={(e: any) => associateFile(e, invoiceRowIndex)} 
                            endIcon={<CloudUpload />}>
                            {uploadLabel}
                            <VisuallyHiddenInput type="file" />
                        </Button>}

                        {hasFile &&
                            <IconButton size='small' edge="end" onClick={() => downloadFile(invoiceKey)}>
                                <PictureAsPdf />
                            </IconButton>}
                    </>
                }
            </>}
            
            {((allowAdd && justAdded) || allowDelete) && 
            <AlertDialog
                dialogTitle={tMvm("dialogDeleteTitle")}
                dialogContentText={tMvm("dialogDeleteContentText")}
                cancelTextButton={tMvm("cancelDeleteTextButton")}
                confirmTextButton={tMvm("confirmDeleteTextButton")}
                confirmDialogFunction={() => removeMvmInvoiceFromList(invoiceRowIndex)}
                Button={
                    <IconButton size='small' edge="end" style={{marginLeft: 10}}>
                        <DeleteIcon />
                    </IconButton>
                }
            />}
        </>
        );
    }

   
    async function AddMvmInvoiceToList() {

        setCircularLoading(true);
        var invoiceKeySearch = refFieldInvoiceKey.current
        if (!invoiceKeySearch)
        {
            setCircularLoading(false);
            return
        }

        var invoiceKey = String(invoiceKeySearch.value)

        if (invoiceKey.length !== 44) {
            enqueueSnackbar(tMvm("invoiceKeyNot44CharValidation"), { variant: 'warning' })
            setCircularLoading(false);
            return
        }

        var data = getValues()
        if (setTypeManually && (!data.invoiceType || !data.invoiceType.code)) {
            enqueueSnackbar(tMvm("invoiceTypeIsRequired"), { variant: 'warning' })
            setCircularLoading(false);
            return
        }
        var existingInvoice = false
        fields.forEach((field) => {
            if ((field as any).invoiceKey === invoiceKey){
            existingInvoice = true
            }
        })

        if (existingInvoice) {
            enqueueSnackbar(tMvm("mvmInvoiceOnList"), { variant: 'warning' })
            setCircularLoading(false)
            return
        }

        var validInvoice = true
        await MvmApi.validateInvoicesInUse({
            mvmId: (Mvm?.id ?? 0),
            invoiceKeys: [ invoiceKey ]
          })
        .catch((err) => {
            setCircularLoading(false)
            validInvoice = false
        })

        if(!validInvoice) {
            return
        }

        let mvmInvoiceTemp: any;
        
        await MvmApi.getInvoiceData((Mvm?.id ?? 0), (Mvm?.companyId ?? 0), user.company.plantID, invoiceKey).then(res => { 
            mvmInvoiceTemp = res.data;
        })
        .catch(() => {setCircularLoading(false)})
        
        if (setTypeManually) {
            mvmInvoiceTemp.invoiceType = data.invoiceType.code
            reset()
        }

        //So adicionar na lista caso saiba o tipo da nota. Senao, usuario deve escolher
        if (mvmInvoiceTemp.invoiceType !== null)
        {
            addInvoiceToList(mvmInvoiceTemp)
        }
        else 
        {
            setUnknownTypeInvoice(mvmInvoiceTemp)
            setSelectInvoiceType(true)
        }

        invoiceKeySearch.value = ""

        setCircularLoading(false)
    }

    const removeMvmInvoiceFromList = (index: number) => {
        remove(index)
    }

    //Adicionar nota fiscal na lista da grid:
    function addInvoiceToList(mvmInvoice:any) {
        
        mvmInvoice.id = 0; //garantir que id = 0 (nova NF inserida na lista): Se a nf veio do elog, pode ter vindo com o id_nota_Fiscal preenchido neste campo erroneamente
        append(mvmInvoice);
        enqueueSnackbar(tMvm("mvmInvoiceAddSuccess"), { variant: 'success' });
    }

    //Usuario escolheu o tipo da nota fiscal:
    async function handleChooseInvoiceType(invoiceType: string) {
        let mvmInvoice = unknownTypeInvoice;

        if (invoiceType === 'cancel')
        {
            setSelectInvoiceType(false);
            setUnknownTypeInvoice(null);
            return;
        }

        //Preencher o tipo e incluir na lista
        if (mvmInvoice !== null)
        {
            mvmInvoice.invoiceType = invoiceType;
            addInvoiceToList(mvmInvoice);
            setSelectInvoiceType(false);
        }
    }

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0 }} >
                {tMvm(title)}
            </Typography>

            {!allowAdd ? <Grid /> :
                <Grid container spacing={1} style={{ marginBottom: 10 }}> 
                    <Grid item >
                        <TextField
                            label={tMvm("invoiceKey")}
                            name="invoiceKeySearch"
                            type='text'
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    AddMvmInvoiceToList()
                                    refFieldInvoiceKey.current?.focus()
                                }
                            }}
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                            style={{ width: 400 }}
                            inputRef={refFieldInvoiceKey} 
                            disabled={entranceDate}
                        />
                    </Grid>
                    
                    {setTypeManually && 
                    <Grid item xs={2}>
                        <SelectInvoiceType 
                            name='invoiceType'
                            label={'invoiceType'}
                            selectRef={refFieldInvoiceType}
                            control={internalControl}
                            style={{marginTop: 0, marginRight: 10}}
                            disabled={entranceDate}
                        />
                    </Grid>}

                    <Tooltip title={entranceDate ? String(tMvm('invoiceWithEntrance')) : ''}>
                        <Grid> 
                            <ButtonUI
                                onClick={() => { AddMvmInvoiceToList(); refFieldInvoiceKey.current?.focus()} }
                                color="primary"
                                variant="contained"
                                style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 15, marginLeft: '10px' }}
                                disabled={entranceDate}
                            >
                                <AddIcon />
                            </ButtonUI> 
                        </Grid>
                    </Tooltip>  
                </Grid>
            }

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Typography className={classes.paper} style={{ marginLeft: 0, marginTop: 0 }} >
                {tGeneral("totalRecords")} {fields ? fields.length : '0'}
            </Typography>
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={invoiceItems}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(tGeneral),
                        serverSide: false,
                        pagination: false,
                        sort: false,
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none', 
                    }}
                />
            </MuiThemeProvider>

            
            {/* Dialog de selecao do tipo da NF */ }
            <Dialog open={selectInvoiceType} scroll="body">
                <DialogTitle>{tMvmInvoice("unknownInvoiceTypeTitle")}</DialogTitle>
                <DialogContent><DialogContentText>{tMvmInvoice("unknownInvoiceTypeText")}</DialogContentText></DialogContent>
                <List>
                    <ListItem button key={'cancel'} onClick={() => handleChooseInvoiceType('cancel')}>
                        <ListItemAvatar>
                            <Avatar>
                            <DeleteIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText>{tMvmInvoice("unknownInvoiceTypeCancel")}</ListItemText>
                    </ListItem>
                    {invoiceTypes.map((x) => {
                        return (
                            <ListItem button key={x} onClick={() => handleChooseInvoiceType(x)}>
                                <ListItemAvatar>
                                    <Avatar>
                                    <AddIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText>{tMvmInvoice("invoiceType_" + x)}</ListItemText>
                            </ListItem>
                        );
                    })}
                </List>
            </Dialog>
        </Grid>
    )
}

export default MvmInvoiceItemsList